import React, { useEffect, useRef, useState } from "react";

const GoogleLoginButton = ({
  clientId,
  onCredential,
  onError,
  theme = "outline",
  size = "large",
  text = "continue_with",
}) => {
  const buttonRef = useRef(null);
  const onCredentialRef = useRef(onCredential);
  const onErrorRef = useRef(onError);
  const [ready, setReady] = useState(false);

  useEffect(() => {
    onCredentialRef.current = onCredential;
  }, [onCredential]);

  useEffect(() => {
    onErrorRef.current = onError;
  }, [onError]);

  useEffect(() => {
    if (!clientId) return;

    let canceled = false;
    let attempts = 0;

    const tryInit = () => {
      if (canceled) return false;

      const google = window.google;
      if (!google || !google.accounts || !google.accounts.id) return false;

      google.accounts.id.initialize({
        client_id: clientId,
        callback: (response) => {
          if (response?.credential) {
            onCredentialRef.current?.(response.credential);
          } else {
            onErrorRef.current?.("Google sign-in failed. Please try again.");
          }
        },
      });

      if (buttonRef.current) {
        buttonRef.current.innerHTML = "";
        google.accounts.id.renderButton(buttonRef.current, {
          theme,
          size,
          text,
          width: 320,
          shape: "rectangular",
        });
      }

      setReady(true);
      return true;
    };

    if (tryInit()) return;

    const timer = setInterval(() => {
      attempts += 1;
      if (tryInit() || attempts >= 10) {
        clearInterval(timer);
        if (attempts >= 10 && !ready) {
          onErrorRef.current?.("Google login is not available right now.");
        }
      }
    }, 300);

    return () => {
      canceled = true;
      clearInterval(timer);
    };
  }, [clientId, theme, size, text, ready]);

  if (!clientId) {
    return (
      <p className="text-xs text-center text-gray-500">
        Google login is not configured.
      </p>
    );
  }

  return <div ref={buttonRef} className="flex justify-center" />;
};

export default GoogleLoginButton;
